// extracted by mini-css-extract-plugin
export default {"loginTitle":"Login_loginTitle__NzNsD"};